class LocalStorage {
  getItem(key) {
    try {
      return window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (error) {
      return null;
    }
  }

  setItem(key, value) {
    try {
      window.localStorage && window.localStorage.setItem(key, value);
    } catch (error) {
      return;
    }
  }
}

const localStorage = new LocalStorage();

export default localStorage;
